import React, { AnchorHTMLAttributes, FC } from 'react';
import NextLink from 'next/link';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Link: FC<AnchorHTMLAttributes<any>> = ({
  href,
  children,
  ...props
}) => (
  <NextLink href={href ?? ''}>
    <a {...props}>{children}</a>
  </NextLink>
);
